import { render, staticRenderFns } from "./materibmtk.vue?vue&type=template&id=29f32f0d&scoped=true"
import script from "./materibmtk.vue?vue&type=script&lang=js"
export * from "./materibmtk.vue?vue&type=script&lang=js"
import style0 from "./materibmtk.vue?vue&type=style&index=0&id=29f32f0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f32f0d",
  null
  
)

export default component.exports